import { Select } from "antd";
import { Field, useFormikContext } from "formik";
import { useTranslation } from "react-i18next";

/**
 * A component that renders a select input with the given options
 *
 * @param {Object} props
 * @param {string} props.label - The label to be displayed on top of the select
 * @param {string} props.name - The HTML name of the input
 * @param {{label: string, value: string}[]} props.options - The select options, the label is what will be shown to the user while the value would be what is submitted when the option is selected
 * @param {string} props.placeholder - The placeholder to be shown when nothing is selected yet
 * @param {(e: string)=>{}} props.onChange - A function that runs when the selected option changes
 * @returns {JSX.Element}
 */

const SelectInput = ({
  label,
  options = [],
  placeholder,
  name,
  onChange,
  customError,
  required,
}) => {
  const { errors, touched } = useFormikContext();
  const { t } = useTranslation("global");
  return (
    <Field name={name}>
      {({ field }) => (
        <div className="flex-1 flex flex-col gap-1">
          <label htmlFor={name}>
            {label} {required && "*"}
          </label>
          <Select
            {...field}
            placeholder={placeholder}
            value={field.value || undefined}
            onChange={onChange}
            onBlur={() => {}}
            virtual={false}
            dropdownRender={DropDownRender}
          >
            {options.map((option) => (
              <Select.Option key={option.value} value={option.value}>
                {option.label}
              </Select.Option>
            ))}
          </Select>
          {errors[name] && touched[name] && (
            <p className="text-text_warning text-sm mt-1 text-start">
              {t(errors[name])}
            </p>
          )}
          {errors[name] && customError && (
            <span style={{ color: "#ff4d4f", fontSize: "small" }}>
              {t(errors[name])}
            </span>
          )}
        </div>
      )}
    </Field>
  );
};

const renderErrorMessage = (msg) => (
  <span
    style={{
      color: "#ff4d4f",
      fontSize: "small",
    }}
  >
    {msg}
  </span>
);

const DropDownRender = (menu) => (
  <div className="max-h-[250px] overflow-auto">{menu}</div>
);

export default SelectInput;
